import React, { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { SpotlightTarget } from '@atlaskit/onboarding';

import {
	ErrorType,
	Severity,
	Product,
	Team,
	createProductSpecificAnalyticsIntegrationPayload,
} from '@atlassian/growth-commons-error-analytics';

import { Attribution, TransparentErrorBoundary } from '@confluence/error-boundary';

import { useRtPaidFeatureEducationActions } from '../hooks/useRtPaidFeatureEducationStore';

export const RtPaidFeatureEducationSpotlightTarget = ({
	children,
	webUi,
}: {
	children: React.ReactNode;
	webUi: string | null;
}) => {
	const { setTemplatePageIdWebUi } = useRtPaidFeatureEducationActions();

	useEffect(() => {
		if (webUi) {
			void setTemplatePageIdWebUi(webUi);
		}
	}, [webUi, setTemplatePageIdWebUi]);

	return <SpotlightTarget name="rt-paid-feature-education-spotlight">{children}</SpotlightTarget>;
};

export const RtPaidFeatureEducationSpotlightTargetWithErrorBoundary = ({
	children,
	webUi,
}: {
	children: React.ReactNode;
	webUi: string | null;
}) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return (
		<TransparentErrorBoundary
			attribution={Attribution.GROWTH_LUNA}
			onError={(error, info) => {
				const eventPayload = createProductSpecificAnalyticsIntegrationPayload({
					product: Product.CONFLUENCE,
					team: Team.GROWTH_LUNA,
					experimentMeta: {
						experimentKey: 'rt_paid_feature_education_ab',
					},
					errorType: ErrorType.ERROR_BOUNDARY,
					errorMessage: error.message,
					severity: Severity.MEDIUM,
					source: 'RtPaidFeatureEducationSpotlightTargetWithErrorBoundary',
					additionalAttributes: {
						...info,
					},
				});

				createAnalyticsEvent(eventPayload).fire();
			}}
		>
			<RtPaidFeatureEducationSpotlightTarget webUi={webUi}>
				{children}
			</RtPaidFeatureEducationSpotlightTarget>
		</TransparentErrorBoundary>
	);
};
